/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RecordingManualChangesResponseFieldsArtists } from './RecordingManualChangesResponseFieldsArtists';
import {
    RecordingManualChangesResponseFieldsArtistsFromJSON,
    RecordingManualChangesResponseFieldsArtistsFromJSONTyped,
    RecordingManualChangesResponseFieldsArtistsToJSON,
} from './RecordingManualChangesResponseFieldsArtists';
import type { RecordingManualChangesResponseFieldsContributions } from './RecordingManualChangesResponseFieldsContributions';
import {
    RecordingManualChangesResponseFieldsContributionsFromJSON,
    RecordingManualChangesResponseFieldsContributionsFromJSONTyped,
    RecordingManualChangesResponseFieldsContributionsToJSON,
} from './RecordingManualChangesResponseFieldsContributions';
import type { RecordingManualChangesResponseFieldsRecordingTitle } from './RecordingManualChangesResponseFieldsRecordingTitle';
import {
    RecordingManualChangesResponseFieldsRecordingTitleFromJSON,
    RecordingManualChangesResponseFieldsRecordingTitleFromJSONTyped,
    RecordingManualChangesResponseFieldsRecordingTitleToJSON,
} from './RecordingManualChangesResponseFieldsRecordingTitle';
import type { RecordingManualChangesResponseFieldsRecordingVersion } from './RecordingManualChangesResponseFieldsRecordingVersion';
import {
    RecordingManualChangesResponseFieldsRecordingVersionFromJSON,
    RecordingManualChangesResponseFieldsRecordingVersionFromJSONTyped,
    RecordingManualChangesResponseFieldsRecordingVersionToJSON,
} from './RecordingManualChangesResponseFieldsRecordingVersion';

/**
 * 
 * @export
 * @interface RecordingManualChangesResponseFields
 */
export interface RecordingManualChangesResponseFields {
    /**
     * 
     * @type {RecordingManualChangesResponseFieldsRecordingTitle}
     * @memberof RecordingManualChangesResponseFields
     */
    recordingTitle?: RecordingManualChangesResponseFieldsRecordingTitle;
    /**
     * 
     * @type {RecordingManualChangesResponseFieldsRecordingTitle}
     * @memberof RecordingManualChangesResponseFields
     */
    duration?: RecordingManualChangesResponseFieldsRecordingTitle;
    /**
     * 
     * @type {RecordingManualChangesResponseFieldsRecordingTitle}
     * @memberof RecordingManualChangesResponseFields
     */
    live?: RecordingManualChangesResponseFieldsRecordingTitle;
    /**
     * 
     * @type {RecordingManualChangesResponseFieldsRecordingTitle}
     * @memberof RecordingManualChangesResponseFields
     */
    yearRecorded?: RecordingManualChangesResponseFieldsRecordingTitle;
    /**
     * 
     * @type {RecordingManualChangesResponseFieldsRecordingTitle}
     * @memberof RecordingManualChangesResponseFields
     */
    countryOfRecording?: RecordingManualChangesResponseFieldsRecordingTitle;
    /**
     * 
     * @type {RecordingManualChangesResponseFieldsRecordingTitle}
     * @memberof RecordingManualChangesResponseFields
     */
    bandArtistName?: RecordingManualChangesResponseFieldsRecordingTitle;
    /**
     * 
     * @type {RecordingManualChangesResponseFieldsRecordingVersion}
     * @memberof RecordingManualChangesResponseFields
     */
    recordingVersion?: RecordingManualChangesResponseFieldsRecordingVersion;
    /**
     * 
     * @type {RecordingManualChangesResponseFieldsRecordingVersion}
     * @memberof RecordingManualChangesResponseFields
     */
    isrcs?: RecordingManualChangesResponseFieldsRecordingVersion;
    /**
     * 
     * @type {RecordingManualChangesResponseFieldsRecordingVersion}
     * @memberof RecordingManualChangesResponseFields
     */
    pNames?: RecordingManualChangesResponseFieldsRecordingVersion;
    /**
     * 
     * @type {RecordingManualChangesResponseFieldsArtists}
     * @memberof RecordingManualChangesResponseFields
     */
    artists?: RecordingManualChangesResponseFieldsArtists;
    /**
     * 
     * @type {RecordingManualChangesResponseFieldsContributions}
     * @memberof RecordingManualChangesResponseFields
     */
    contributions?: RecordingManualChangesResponseFieldsContributions;
}

/**
 * Check if a given object implements the RecordingManualChangesResponseFields interface.
 */
export function instanceOfRecordingManualChangesResponseFields(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RecordingManualChangesResponseFieldsFromJSON(json: any): RecordingManualChangesResponseFields {
    return RecordingManualChangesResponseFieldsFromJSONTyped(json, false);
}

export function RecordingManualChangesResponseFieldsFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecordingManualChangesResponseFields {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'recordingTitle': !exists(json, 'recordingTitle') ? undefined : RecordingManualChangesResponseFieldsRecordingTitleFromJSON(json['recordingTitle']),
        'duration': !exists(json, 'duration') ? undefined : RecordingManualChangesResponseFieldsRecordingTitleFromJSON(json['duration']),
        'live': !exists(json, 'live') ? undefined : RecordingManualChangesResponseFieldsRecordingTitleFromJSON(json['live']),
        'yearRecorded': !exists(json, 'yearRecorded') ? undefined : RecordingManualChangesResponseFieldsRecordingTitleFromJSON(json['yearRecorded']),
        'countryOfRecording': !exists(json, 'countryOfRecording') ? undefined : RecordingManualChangesResponseFieldsRecordingTitleFromJSON(json['countryOfRecording']),
        'bandArtistName': !exists(json, 'bandArtistName') ? undefined : RecordingManualChangesResponseFieldsRecordingTitleFromJSON(json['bandArtistName']),
        'recordingVersion': !exists(json, 'recordingVersion') ? undefined : RecordingManualChangesResponseFieldsRecordingVersionFromJSON(json['recordingVersion']),
        'isrcs': !exists(json, 'isrcs') ? undefined : RecordingManualChangesResponseFieldsRecordingVersionFromJSON(json['isrcs']),
        'pNames': !exists(json, 'pNames') ? undefined : RecordingManualChangesResponseFieldsRecordingVersionFromJSON(json['pNames']),
        'artists': !exists(json, 'artists') ? undefined : RecordingManualChangesResponseFieldsArtistsFromJSON(json['artists']),
        'contributions': !exists(json, 'contributions') ? undefined : RecordingManualChangesResponseFieldsContributionsFromJSON(json['contributions']),
    };
}

export function RecordingManualChangesResponseFieldsToJSON(value?: RecordingManualChangesResponseFields | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'recordingTitle': RecordingManualChangesResponseFieldsRecordingTitleToJSON(value.recordingTitle),
        'duration': RecordingManualChangesResponseFieldsRecordingTitleToJSON(value.duration),
        'live': RecordingManualChangesResponseFieldsRecordingTitleToJSON(value.live),
        'yearRecorded': RecordingManualChangesResponseFieldsRecordingTitleToJSON(value.yearRecorded),
        'countryOfRecording': RecordingManualChangesResponseFieldsRecordingTitleToJSON(value.countryOfRecording),
        'bandArtistName': RecordingManualChangesResponseFieldsRecordingTitleToJSON(value.bandArtistName),
        'recordingVersion': RecordingManualChangesResponseFieldsRecordingVersionToJSON(value.recordingVersion),
        'isrcs': RecordingManualChangesResponseFieldsRecordingVersionToJSON(value.isrcs),
        'pNames': RecordingManualChangesResponseFieldsRecordingVersionToJSON(value.pNames),
        'artists': RecordingManualChangesResponseFieldsArtistsToJSON(value.artists),
        'contributions': RecordingManualChangesResponseFieldsContributionsToJSON(value.contributions),
    };
}

